import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=67b076db"
import script from "./CompanyItem.vue?vue&type=script&lang=ts"
export * from "./CompanyItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports